import { timePeriodEnum } from "./type";

export const metricsMockData = [
    {
        "metric_name": "Prospects Under Nurturing",
        "count": 50,
        "type": "OPPORTUNITY_ADDED_IN_NURTURING",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 1000, pv: 800, amt: 700 },
            { name: 'Page B', uv: 1500, pv: 1200, amt: 900 },
            { name: 'Page C', uv: 1200, pv: 1100, amt: 1000 },
            { name: 'Page D', uv: 2000, pv: 1600, amt: 1400 },
            { name: 'Page E', uv: 2500, pv: 2000, amt: 1900 },
            { name: 'Page F', uv: 3200, pv: 2500, amt: 2400 },
            { name: 'Page G', uv: 4000, pv: 3100, amt: 3000 },
        ]
    },
    {
        "metric_name": "Target Buyer Profiles",
        "count": 13,
        "type": "SEGMENT",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 500, pv: 600, amt: 550 },
            { name: 'Page B', uv: 800, pv: 1000, amt: 700 },
            { name: 'Page C', uv: 1200, pv: 1400, amt: 1200 },
            { name: 'Page D', uv: 1000, pv: 1300, amt: 1100 },
            { name: 'Page E', uv: 1700, pv: 1900, amt: 1800 },
            { name: 'Page F', uv: 2200, pv: 2300, amt: 2100 },
            { name: 'Page G', uv: 3000, pv: 3200, amt: 2900 },
        ]
    },
    {
        "metric_name": "Engagement Rate",
        "count": "80%",
        "type": "ENGAGEMENT",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 4000, pv: 3000, amt: 2000 },
            { name: 'Page B', uv: 4500, pv: 3200, amt: 2500 },
            { name: 'Page C', uv: 4100, pv: 3100, amt: 2300 },
            { name: 'Page D', uv: 5000, pv: 3500, amt: 2700 },
            { name: 'Page E', uv: 5500, pv: 4000, amt: 3000 },
            { name: 'Page F', uv: 6000, pv: 4500, amt: 3300 },
            { name: 'Page G', uv: 7000, pv: 5000, amt: 4000 },
        ]
    },
    {
        "metric_name": "Unsubscribe Rate",
        "count": "3%",
        "type": "LEAD_UNSUBSCRIBED",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 200, pv: 150, amt: 180 },
            { name: 'Page B', uv: 300, pv: 250, amt: 200 },
            { name: 'Page C', uv: 280, pv: 300, amt: 220 },
            { name: 'Page D', uv: 400, pv: 350, amt: 300 },
            { name: 'Page E', uv: 500, pv: 450, amt: 400 },
            { name: 'Page F', uv: 700, pv: 600, amt: 500 },
            { name: 'Page G', uv: 1000, pv: 900, amt: 800 },
        ]
    },
    {
        "metric_name": "Infuenced Dormant Lead Contacted",
        "count": 10,
        "type": "LEAD_CONTACTED",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 800, pv: 1000, amt: 900 },
            { name: 'Page B', uv: 1200, pv: 1400, amt: 1300 },
            { name: 'Page C', uv: 1100, pv: 1300, amt: 1200 },
            { name: 'Page D', uv: 1500, pv: 1700, amt: 1600 },
            { name: 'Page E', uv: 1800, pv: 2000, amt: 1900 },
            { name: 'Page F', uv: 2500, pv: 2600, amt: 2400 },
            { name: 'Page G', uv: 3200, pv: 3300, amt: 3000 },
        ]
    },
    {
        "metric_name": "Infuenced Sales",
        "count": 3,
        "type": "LEAD_SOLD",
        "filter_used": {
            "time_period": "CURRENT_MONTH"
        },
        graph_data: [
            { name: 'Page A', uv: 400, pv: 300, amt: 200 },
            { name: 'Page B', uv: 600, pv: 500, amt: 400 },
            { name: 'Page C', uv: 550, pv: 450, amt: 350 },
            { name: 'Page D', uv: 800, pv: 700, amt: 600 },
            { name: 'Page E', uv: 1000, pv: 900, amt: 850 },
            { name: 'Page F', uv: 1300, pv: 1200, amt: 1100 },
            { name: 'Page G', uv: 1800, pv: 1500, amt: 1400 },
        ]
    }
];

export const mockGraphData = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
]

export const timeperiodMockData = [
    {
        "code": timePeriodEnum.ALL_TIME,
        "name": "All Time"
    },
    {
        "code": timePeriodEnum.TODAY,
        "name": "Today"
    },
    {
        "code": timePeriodEnum.YESTERDAY,
        "name": "Yesterday"
    },
    {
        "code": timePeriodEnum.THIS_WEEK,
        "name": "This Week"
    },
    {
        "code": timePeriodEnum.LAST_WEEK,
        "name": "Last Week"
    },
    {
        "code": timePeriodEnum.WEEK_TO_DATE,
        "name": "Week to Date"
    },
    {
        "code": timePeriodEnum.THIS_MONTH,
        "name": "This Month"
    },
    {
        "code": timePeriodEnum.LAST_MONTH,
        "name": "Last Month"
    },
    {
        "code": timePeriodEnum.MONTH_TO_DATE,
        "name": "Month to Date"
    },
    {
        "code": timePeriodEnum.THIS_QUARTER,
        "name": "This Quarter"
    },
    {
        "code": timePeriodEnum.LAST_QUARTER,
        "name": "Last Quarter"
    },
    {
        "code": timePeriodEnum.QUARTER_TO_DATE,
        "name": "Quarter to Date"
    },
    {
        "code": timePeriodEnum.THIS_YEAR,
        "name": "This Year"
    },
    {
        "code": timePeriodEnum.LAST_YEAR,
        "name": "Last Year"
    },
    {
        "code": timePeriodEnum.YEAR_TO_DATE,
        "name": "Year to Date"
    },
    {
        "code": timePeriodEnum.SIX_MONTHS,
        "name": "Six Months"
    },
    // Optional dynamic date ranges
    // {
    //     "code": timePeriodEnum.SINCE,
    //     "name": "Since a Specific Date"
    // },
    // {
    //     "code": timePeriodEnum.LAST,
    //     "name": "Last N Days"
    // }
];

export const allLeadsMockData = {
    "data": [
        {
            _id: 1,
            "lead_details_in_a_string": "John Wick",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "status": "Yes",
            "days": "250",
            "day_in_nurturing": "150",
            "no_of_messages": "30",
        },
        {
            _id: 2,
            "lead_details_in_a_string": "John Doe",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "280",
            "day_in_nurturing": "180",
            "no_of_messages": "34",
        },
        {
            _id: 3,
            "lead_details_in_a_string": "Michael Scott",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "230",
            "day_in_nurturing": "140",
            "no_of_messages": "28",
        }
    ],
    "totalPages": 13,
    "currentPage": 0,
    "totalDocuments": 13,
    "headers": [
        {
            "display_name": "Buyer",
            "input_file_field": "lead_details_in_a_string",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "lead_details_in_a_string"
        },
        {
            "display_name": "Date In",
            "input_file_field": "date_in",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_in"
        },
        {
            "display_name": "Date Contacted",
            "input_file_field": "date_contacted",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_contacted"
        },
        {
            "display_name": "Date Sold",
            "input_file_field": "date_sold",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_sold"
        },
        {
            "display_name": "Sold Y / N",
            "input_file_field": "status",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "status"
        },
        {
            "display_name": "Lead - to - Revival Days",
            "input_file_field": "days",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "days"
        },
        {
            "display_name": "Days in Nurturing",
            "input_file_field": "day_in_nurturing",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "day_in_nurturing"
        },
        {
            "display_name": "# Nurturing Messages",
            "input_file_field": "no_of_messages",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "no_of_messages"
        }]
}

export const leadsContactedMockData = {
    "data": [
        {
            _id: 1,
            "lead_details_in_a_string": "John Wick",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "status": "Yes",
            "days": "250",
            "day_in_nurturing": "150",
            "no_of_messages": "30",
        },
        {
            _id: 2,
            "lead_details_in_a_string": "John Doe",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "280",
            "day_in_nurturing": "180",
            "no_of_messages": "34",
        },
        {
            _id: 3,
            "lead_details_in_a_string": "Michael Scott",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "230",
            "day_in_nurturing": "140",
            "no_of_messages": "28",
        }
    ],
    "totalPages": 13,
    "currentPage": 0,
    "totalDocuments": 13,
    "headers": [
        {
            "display_name": "Buyer",
            "input_file_field": "lead_details_in_a_string",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "lead_details_in_a_string"
        },
        {
            "display_name": "Date In",
            "input_file_field": "date_in",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_in"
        },
        {
            "display_name": "Date Contacted",
            "input_file_field": "date_contacted",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_contacted"
        },
        {
            "display_name": "Sold Y / N",
            "input_file_field": "status",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "status"
        },
        {
            "display_name": "Lead - to - Revival Days",
            "input_file_field": "days",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "days"
        },
        {
            "display_name": "Days in Nurturing",
            "input_file_field": "day_in_nurturing",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "day_in_nurturing"
        },
        {
            "display_name": "# Nurturing Messages",
            "input_file_field": "no_of_messages",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "no_of_messages"
        }]
}

export const leadsSoldMockData = {
    "data": [
        {
            _id: 1,
            "lead_details_in_a_string": "John Wick",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "status": "Yes",
            "days": "250",
            "day_in_nurturing": "150",
            "no_of_messages": "30",
            vehicle_bought: "Honda CR-V",
            gross_influenced: "$1800"
        },
        {
            _id: 2,
            "lead_details_in_a_string": "John Doe",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "280",
            "day_in_nurturing": "180",
            "no_of_messages": "34",
            vehicle_bought: "Honda HR-V",
            gross_influenced: "$1400"
        },
        {
            _id: 3,
            "lead_details_in_a_string": "Michael Scott",
            "date_in": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_contacted": new Date(Date.now() - Math.random() * 2 * 365 * 24 * 60 * 60 * 1000).toISOString(),
            "date_sold": "",
            "status": "No",
            "days": "230",
            "day_in_nurturing": "140",
            "no_of_messages": "28",
            vehicle_bought: "Honda Accord",
            gross_influenced: "$2000"
        }

    ],
    "totalPages": 13,
    "currentPage": 0,
    "totalDocuments": 13,
    "headers": [
        {
            "display_name": "Buyer",
            "input_file_field": "lead_details_in_a_string",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "lead_details_in_a_string"
        },
        {
            "display_name": "Date In",
            "input_file_field": "date_in",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_in"
        },
        {
            "display_name": "Date Sold",
            "input_file_field": "date_sold",
            "field_data_type": "date",
            "field_required": false,
            "null_allowed": true,
            "db_field": "date_sold"
        },
        {
            "display_name": "Lead - to - Sale Days",
            "input_file_field": "days",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "days"
        },
        {
            "display_name": "Days in Nurturing",
            "input_file_field": "day_in_nurturing",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "day_in_nurturing"
        },
        {
            "display_name": "# Nurturing Messages",
            "input_file_field": "no_of_messages",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "no_of_messages"
        },
        {
            "display_name": "Vehicle Bought",
            "input_file_field": "vehicle_bought",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "vehicle_bought"
        },
        {
            "display_name": "Gross Influenced",
            "input_file_field": "gross_influenced",
            "field_data_type": "string",
            "field_required": false,
            "null_allowed": true,
            "db_field": "gross_influenced"
        }
    ]
}

export const segmentsMockData = {
    "data": [
        {
            "last_added_date": "2024-11-26T13:27:28.102Z",
            "_id": "6745cbf1700a4638fb321c5f",
            "type": "SEGMENT",
            "status": "NOT_UNDER_NURTURING",
            "name": "Odyssey",
            "details": {
                "last_added_date": "2024-11-26T13:27:28.102Z"
            },
            "created_at": "2024-11-26T13:24:01.389Z",
            "updated_at": "2024-11-26T13:27:28.404Z",
            "MAIL_FORWARD": 0,
            "MAIL_REPLIED": 0,
            "MAIL_SPAMREPORT": 0,
            "MAIL_DROPPED": 0,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 0,
            "MAIL_BOUNCED": 0,
            "MAIL_COMPLAINED": 0,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 0,
            "MAIL_OPENED": 0,
            "MAIL_DELIVERED": 0,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 8,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 10,
            "LEAD_SOLD": 5,
            "no_of_leads": 200,
            "leads_in_nurturing": 100
        },
        {
            "last_added_date": "2024-11-26T13:27:30.068Z",
            "first_email_sent_date": "2024-11-27T13:34:09.219Z",
            "last_email_sent_date": "2024-12-02T09:16:23.913Z",
            "first_opportunity_added_in_nurturing_date": "2024-11-28T11:52:09.894Z",
            "first_mail_delivered_date": "2024-11-28T11:52:09.894Z",
            "last_opportunity_added_in_nurturing_date": "2024-11-28T11:52:39.217Z",
            "last_mail_delivered_date": "2024-12-02T09:16:23.913Z",
            "first_mail_opened_date": "2024-11-28T11:52:09.895Z",
            "last_mail_opened_date": "2024-12-02T09:16:23.914Z",
            "first_mail_clicked_date": "2024-11-28T11:52:09.895Z",
            "last_mail_clicked_date": "2024-12-02T09:16:23.914Z",
            "first_mail_complained_date": "2024-11-28T11:52:09.895Z",
            "last_mail_complained_date": "2024-12-02T09:16:23.914Z",
            "first_mail_bounced_date": "2024-11-28T11:52:09.896Z",
            "last_mail_bounced_date": "2024-12-02T09:16:23.914Z",
            "first_mail_failed_date": "2024-11-28T11:52:09.896Z",
            "last_mail_failed_date": "2024-12-02T09:16:23.914Z",
            "first_mail_dropped_date": "2024-11-28T11:52:09.896Z",
            "last_mail_dropped_date": "2024-12-02T09:16:23.914Z",
            "first_mail_spamreport_date": "2024-11-28T11:52:09.896Z",
            "last_mail_spamreport_date": "2024-12-02T09:16:23.914Z",
            "first_mail_replied_date": "2024-11-28T11:52:09.896Z",
            "last_mail_replied_date": "2024-12-02T09:16:23.914Z",
            "first_mail_forward_date": "2024-11-28T11:52:09.896Z",
            "last_mail_forward_date": "2024-12-02T09:16:23.914Z",
            "_id": "6745cbf3700a4638fb321c79",
            "type": "SEGMENT",
            "status": "UNDER_NURTURING",
            "name": "CRV",
            "details": {
                "last_added_date": "2024-11-26T13:27:30.068Z",
                "first_email_sent_date": "2024-11-27T13:34:09.219Z",
                "last_email_sent_date": "2024-12-02T09:16:23.913Z",
                "first_opportunity_added_in_nurturing_date": "2024-11-28T11:52:09.894Z",
                "first_mail_delivered_date": "2024-11-28T11:52:09.894Z",
                "last_opportunity_added_in_nurturing_date": "2024-11-28T11:52:39.217Z",
                "last_mail_delivered_date": "2024-12-02T09:16:23.913Z",
                "first_mail_opened_date": "2024-11-28T11:52:09.895Z",
                "last_mail_opened_date": "2024-12-02T09:16:23.914Z",
                "first_mail_clicked_date": "2024-11-28T11:52:09.895Z",
                "last_mail_clicked_date": "2024-12-02T09:16:23.914Z",
                "first_mail_complained_date": "2024-11-28T11:52:09.895Z",
                "last_mail_complained_date": "2024-12-02T09:16:23.914Z",
                "first_mail_bounced_date": "2024-11-28T11:52:09.896Z",
                "last_mail_bounced_date": "2024-12-02T09:16:23.914Z",
                "first_mail_failed_date": "2024-11-28T11:52:09.896Z",
                "last_mail_failed_date": "2024-12-02T09:16:23.914Z",
                "first_mail_dropped_date": "2024-11-28T11:52:09.896Z",
                "last_mail_dropped_date": "2024-12-02T09:16:23.914Z",
                "first_mail_spamreport_date": "2024-11-28T11:52:09.896Z",
                "last_mail_spamreport_date": "2024-12-02T09:16:23.914Z",
                "first_mail_replied_date": "2024-11-28T11:52:09.896Z",
                "last_mail_replied_date": "2024-12-02T09:16:23.914Z",
                "first_mail_forward_date": "2024-11-28T11:52:09.896Z",
                "last_mail_forward_date": "2024-12-02T09:16:23.914Z"
            },
            "created_at": "2024-11-26T13:24:03.580Z",
            "updated_at": "2024-12-02T10:16:46.037Z",
            "MAIL_FORWARD": 20,
            "MAIL_REPLIED": 20,
            "MAIL_SPAMREPORT": 20,
            "MAIL_DROPPED": 20,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 20,
            "MAIL_BOUNCED": 20,
            "MAIL_COMPLAINED": 20,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 20,
            "MAIL_OPENED": 20,
            "MAIL_DELIVERED": 20,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 13,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 26,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 20,
            "LEAD_SOLD": 10,
            "no_of_leads": 250,
            "leads_in_nurturing": 150
        },
        {
            "last_added_date": "2024-11-26T13:27:21.824Z",
            "first_email_sent_date": "2024-11-26T12:36:10.987Z",
            "last_email_sent_date": "2024-11-26T12:36:33.664Z",
            "_id": "6745cbf7700a4638fb321cb6",
            "type": "SEGMENT",
            "status": "PAUSED",
            "name": "Accord",
            "details": {
                "last_added_date": "2024-11-26T13:27:21.824Z",
                "first_email_sent_date": "2024-11-26T12:36:10.987Z",
                "last_email_sent_date": "2024-11-26T12:36:33.664Z"
            },
            "created_at": "2024-11-26T13:24:07.940Z",
            "updated_at": "2024-11-27T14:23:36.143Z",
            "MAIL_FORWARD": 6,
            "MAIL_REPLIED": 6,
            "MAIL_SPAMREPORT": 6,
            "MAIL_DROPPED": 6,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 6,
            "MAIL_BOUNCED": 6,
            "MAIL_COMPLAINED": 6,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 6,
            "MAIL_OPENED": 6,
            "MAIL_DELIVERED": 6,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 8,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 30,
            "LEAD_SOLD": 15,
            "no_of_leads": 300,
            "leads_in_nurturing": 200
        },
        {
            "last_added_date": "2024-11-26T13:26:37.464Z",
            "_id": "6745cbff700a4638fb321d0d",
            "type": "SEGMENT",
            "status": "NOT_UNDER_NURTURING",
            "name": "Ridgeline",
            "details": {
                "last_added_date": "2024-11-26T13:26:37.464Z"
            },
            "created_at": "2024-11-26T13:24:15.243Z",
            "updated_at": "2024-11-26T13:26:37.948Z",
            "MAIL_FORWARD": 0,
            "MAIL_REPLIED": 0,
            "MAIL_SPAMREPORT": 0,
            "MAIL_DROPPED": 0,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 0,
            "MAIL_BOUNCED": 0,
            "MAIL_COMPLAINED": 0,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 0,
            "MAIL_OPENED": 0,
            "MAIL_DELIVERED": 0,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 4,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 40,
            "LEAD_SOLD": 20,
            "no_of_leads": 350,
            "leads_in_nurturing": 250
        },
        {
            "last_added_date": "2024-11-26T13:27:11.606Z",
            "_id": "6745cc01700a4638fb321d2b",
            "type": "SEGMENT",
            "status": "NOT_UNDER_NURTURING",
            "name": "Civic",
            "details": {
                "last_added_date": "2024-11-26T13:27:11.606Z"
            },
            "created_at": "2024-11-26T13:24:17.444Z",
            "updated_at": "2024-11-26T13:27:11.933Z",
            "MAIL_FORWARD": 0,
            "MAIL_REPLIED": 0,
            "MAIL_SPAMREPORT": 0,
            "MAIL_DROPPED": 0,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 0,
            "MAIL_BOUNCED": 0,
            "MAIL_COMPLAINED": 0,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 0,
            "MAIL_OPENED": 0,
            "MAIL_DELIVERED": 0,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 11,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 50,
            "LEAD_SOLD": 25,
            "no_of_leads": 400,
            "leads_in_nurturing": 300
        },
        {
            "last_added_date": "2024-11-26T13:27:19.906Z",
            "_id": "6745cc14700a4638fb321e1d",
            "type": "SEGMENT",
            "status": "NOT_UNDER_NURTURING",
            "name": "Pilot",
            "details": {
                "last_added_date": "2024-11-26T13:27:19.906Z"
            },
            "created_at": "2024-11-26T13:24:36.693Z",
            "updated_at": "2024-11-26T13:27:20.218Z",
            "MAIL_FORWARD": 0,
            "MAIL_REPLIED": 0,
            "MAIL_SPAMREPORT": 0,
            "MAIL_DROPPED": 0,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 0,
            "MAIL_BOUNCED": 0,
            "MAIL_COMPLAINED": 0,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 0,
            "MAIL_OPENED": 0,
            "MAIL_DELIVERED": 0,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 15,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 60,
            "LEAD_SOLD": 30,
            "no_of_leads": 450,
            "leads_in_nurturing": 350
        },
        {
            "last_added_date": "2024-11-26T13:27:07.170Z",
            "_id": "6745cc2c700a4638fb321f49",
            "type": "SEGMENT",
            "status": "NOT_UNDER_NURTURING",
            "name": "HRV",
            "details": {
                "last_added_date": "2024-11-26T13:27:07.170Z"
            },
            "created_at": "2024-11-26T13:25:00.386Z",
            "updated_at": "2024-11-26T13:27:07.472Z",
            "MAIL_FORWARD": 0,
            "MAIL_REPLIED": 0,
            "MAIL_SPAMREPORT": 0,
            "MAIL_DROPPED": 0,
            "MAIL_SENT": 0,
            "MAIL_FAILED": 0,
            "MAIL_BOUNCED": 0,
            "MAIL_COMPLAINED": 0,
            "MAIL_UNSUBSCRIBED": 0,
            "MAIL_CLICKED": 0,
            "MAIL_OPENED": 0,
            "MAIL_DELIVERED": 0,
            "CRM_UPDATED": 0,
            "THIRD_PARTY_API_INVOKED": 0,
            "OPPORTUNITY_UNSUBSCRIBED": 0,
            "OPPORTUNITY_REMOVED_FROM_NURTURING": 0,
            "OPPORTUNITY_ADDED_IN_NURTURING": 0,
            "PROSPECTS_IN_COHORT_TYPE_REMOVED": 0,
            "PROSPECTS_IN_COHORT_TYPE_ADDED": 0,
            "OPPORTUNITY_REMOVED": 0,
            "OPPORTUNITY_ADDED": 3,
            "SHOPPER_REMOVED": 0,
            "SHOPPER_ADDED": 0,
            "DF_DELETED": 0,
            "DF_UPLOADED": 0,
            "EMAIL_BOUNCED": 0,
            "EMAIL_UNSUBSCRIBED": 0,
            "EMAIL_CLICKED": 0,
            "LEAD_UNSUBSCRIBED": 0,
            "LEAD_CONTACTED": 70,
            "LEAD_SOLD": 35,
            "no_of_leads": 500,
            "leads_in_nurturing": 400
        }
    ],
    "headers": [
        {
            "display_name": "Target",
            "input_file_field": "Target",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "name"
        },
        {
            "display_name": "Prospects",
            "input_file_field": "Prospects",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "no_of_leads"
        },
        {
            "display_name": "Contacted",
            "input_file_field": "Contacted",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "LEAD_CONTACTED"
        },
        {
            "display_name": "Sold",
            "input_file_field": "Sold",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "LEAD_SOLD"
        },
        {
            "display_name": "Replies",
            "input_file_field": "Replies",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "MAIL_REPLIED"
        },
        {
            "display_name": "Opens",
            "input_file_field": "Opens",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "MAIL_OPENED"
        },
        {
            "display_name": "Clicks",
            "input_file_field": "Clicks",
            "field_data_type": "string",
            "field_required": true,
            "null_allowed": true,
            "db_field": "MAIL_CLICKED"
        }
    ]
}

export const nurturingHistoryMockData = {
    "shopper": {
        "status": true,
        "_id": "66f400d4758402bd43470400",
        "first_name": "Melanie",
        "email": "gaymichael@example.org",
        "last_name": "Smith",
        "__v": 0,
        "address": "026 Wall Spur",
        "city": "North Robin",
        "created_at": "2024-09-25T12:23:47.937Z",
        "dealer_id": "6347cfa62ea1ef6482ab0d3e",
        "lead_created_date_crm": null,
        "lead_data_feed_id": "66f400c0a0bd50483b3e191a",
        "middle_name": null,
        "phone": "(685)421-6959",
        "phone1": "4124883715",
        "phone2": null,
        "state": "TN",
        "updated_at": "2024-09-25T12:23:47.937Z",
        "zip": "37656"
    },
    "opportunities": [
        {
            "_id": 1,
            "source": "other",
            "voi_status": "New",
            "sales_person": "WAYNE WARREN",
            "New_Auto_Class": "SMALL CAR",
            "lead_data_feed_id": "66f400c0a0bd50483b3e191a",
            "dealer_id": "6347cfa62ea1ef6482ab0d3e",
            "shopper_id": "66f400d4758402bd43470400",
            "created_at": "2024-09-25T12:23:48.259Z",
            "updated_at": "2024-10-01T13:36:05.134Z",
            "__v": 0,
            "nurturing_dates": {
                "unsubscribed_date": "2024-01-24T11:08:27.372Z"
            },
            "nurturing_status": "UNSUBSCRIBED",
            "original_lead": {
                "source": "Internet Up",
                "lead_in_date": "2024-04-11T00:00:00.000Z",
                "interested_vehicle": "2024-2024 and Older HONDA CIVIC",
                "status": "INACTIVE"
            },
            "nurtured_lead": {
                "source": "WEBSITE",
                "lead_in_date": "2024-12-02T10:52:41.396Z",
                "interested_vehicle": "2024 Nissan Ranchero",
                "status": "CONTACTED"
            }
        }
    ],
    "nurturing_tasks": [
        {
            "_id": "66fd34ca3ac9629a6811e640",
            "nurturing_task_type": "EMAIL",
            "status": "PROCESSED",
            "executed_at": "2024-10-02T11:56:02.125Z",
            "scheduled_at": "2024-10-02T00:40:00.000Z",
            "nurturing_event_dates_summary": {
                "first_delivered_date": "2024-04-11T21:03:59.721Z",
                "last_delivered_date": "2024-04-11T21:03:59.721Z",
                "first_opened_date": "2023-11-18T03:07:32.122Z",
                "last_opened_date": "2023-11-18T03:07:32.122Z",
                "first_clicked_date": "2024-02-12T20:22:22.224Z",
                "last_clicked_date": "2024-02-12T20:22:22.224Z",
                "first_unsubscribed_date": "2024-06-14T14:45:48.104Z",
                "last_unsubscribed_date": "2024-06-14T14:45:48.104Z",
                "first_complained_date": "2023-12-06T19:01:07.810Z",
                "last_complained_date": "2023-12-06T19:01:07.810Z",
                "first_bounced_date": "2024-02-07T01:11:49.099Z",
                "last_bounced_date": "2024-02-07T01:11:49.099Z",
                "first_failed_date": "2024-02-17T13:20:42.341Z",
                "last_failed_date": "2024-02-17T13:20:42.341Z",
                "first_sent_date": "2023-12-18T06:19:19.952Z",
                "last_sent_date": "2023-12-18T06:19:19.952Z",
                "first_dropped_date": "2024-03-15T11:43:49.566Z",
                "last_dropped_date": "2024-03-15T11:43:49.566Z",
                "first_spamreport_date": "2024-09-17T00:03:24.555Z",
                "last_spamreport_date": "2024-09-17T00:03:24.555Z",
                "first_replied_date": "2023-11-18T21:07:19.389Z",
                "last_replied_date": "2023-11-18T21:07:19.389Z",
                "first_forward_date": "2024-02-03T00:52:44.143Z",
                "last_forward_date": "2024-02-03T00:52:44.143Z"
            },
            "nurturing_event_metrics": {
                "FORWARD": 1,
                "REPLIED": 1,
                "SPAMREPORT": 1,
                "DROPPED": 1,
                "SENT": 1,
                "FAILED": 1,
                "BOUNCED": 1,
                "COMPLAINED": 1,
                "UNSUBSCRIBED": 1,
                "CLICKED": 1,
                "OPENED": 1,
                "DELIVERED": 1
            },
            "execution_details": {
                "subject": "Mock Data - Need help picking the right Hyundai Sonata?",
                "html_link": "https://dev-node-api.myautoiq.net/api/v2/html-viewer/by-task-id/66fd34ca3ac9629a6811e640",
                "message_id": "66fd34d13ac9629a6811e656"
            },
            "reason": "Error assigning slots."
        }
    ]
};

export const mockHtml = `
    <!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">\n<html dir=\"ltr\" xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\" lang=\"en\" style=\"padding:0;Margin:0\">\n <head>\n  <meta charset=\"UTF-8\">\n  <meta content=\"width=device-width, initial-scale=1\" name=\"viewport\">\n  <meta name=\"x-apple-disable-message-reformatting\">\n  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n  <meta content=\"telephone=no\" name=\"format-detection\">\n  <title>Chambersburg Hyundai has options for you</title><!--[if (mso 16)]>\n    <style type=\"text/css\">\n    a {text-decoration: none;}\n    </style>\n    <![endif]--><!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--><!--[if gte mso 9]>\n<xml>\n    <o:OfficeDocumentSettings>\n    <o:AllowPNG></o:AllowPNG>\n    <o:PixelsPerInch>96</o:PixelsPerInch>\n    </o:OfficeDocumentSettings>\n</xml>\n<![endif]--><!--[if !mso]><!-- -->\n  <link href=\"https://fonts.cdnfonts.com/css/hyundai\" rel=\"stylesheet\"><!--<![endif]--><!--[if !mso]><!-- -->\n  <link href=\"https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i\" rel=\"stylesheet\"><!--<![endif]-->\n  <style type=\"text/css\">\n#outlook a {\n\tpadding:0;\n}\n.ExternalClass {\n\twidth:100%;\n}\n.ExternalClass,\n.ExternalClass p,\n.ExternalClass span,\n.ExternalClass font,\n.ExternalClass td,\n.ExternalClass div {\n\tline-height:100%;\n}\n.es-button {\n\tmso-style-priority:100!important;\n\ttext-decoration:none!important;\n}\na[x-apple-data-detectors] {\n\tcolor:inherit!important;\n\ttext-decoration:none!important;\n\tfont-size:inherit!important;\n\tfont-family:inherit!important;\n\tfont-weight:inherit!important;\n\tline-height:inherit!important;\n}\n.es-desk-hidden {\n\tdisplay:none;\n\tfloat:left;\n\toverflow:hidden;\n\twidth:0;\n\tmax-height:0;\n\tline-height:0;\n\tmso-hide:all;\n}\n@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:30px!important; text-align:center } h2 { font-size:26px!important; text-align:center } h3 { font-size:20px!important; text-align:center } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:30px!important } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class=\"gmail-fix\"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0!important } .es-m-p0r { padding-right:0!important } .es-m-p0l { padding-left:0!important } .es-m-p0t { padding-top:0!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } a.es-button, button.es-button { font-size:20px!important; display:block!important; padding:10px 0px 10px 0px!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } .es-m-p5 { padding:5px!important } .es-m-p5t { padding-top:5px!important } .es-m-p5b { padding-bottom:5px!important } .es-m-p5r { padding-right:5px!important } .es-m-p5l { padding-left:5px!important } .es-m-p10 { padding:10px!important } .es-m-p10t { padding-top:10px!important } .es-m-p10b { padding-bottom:10px!important } .es-m-p10r { padding-right:10px!important } .es-m-p10l { padding-left:10px!important } .es-m-p15 { padding:15px!important } .es-m-p15t { padding-top:15px!important } .es-m-p15b { padding-bottom:15px!important } .es-m-p15r { padding-right:15px!important } .es-m-p15l { padding-left:15px!important } .es-m-p20 { padding:20px!important } .es-m-p20t { padding-top:20px!important } .es-m-p20r { padding-right:20px!important } .es-m-p20l { padding-left:20px!important } .es-m-p25 { padding:25px!important } .es-m-p25t { padding-top:25px!important } .es-m-p25b { padding-bottom:25px!important } .es-m-p25r { padding-right:25px!important } .es-m-p25l { padding-left:25px!important } .es-m-p30 { padding:30px!important } .es-m-p30t { padding-top:30px!important } .es-m-p30b { padding-bottom:30px!important } .es-m-p30r { padding-right:30px!important } .es-m-p30l { padding-left:30px!important } .es-m-p35 { padding:35px!important } .es-m-p35t { padding-top:35px!important } .es-m-p35b { padding-bottom:35px!important } .es-m-p35r { padding-right:35px!important } .es-m-p35l { padding-left:35px!important } .es-m-p40 { padding:40px!important } .es-m-p40t { padding-top:40px!important } .es-m-p40b { padding-bottom:40px!important } .es-m-p40r { padding-right:40px!important } .es-m-p40l { padding-left:40px!important } }\n@media screen and (max-width:384px) {.mail-message-content { width:414px!important } }\n</style>\n </head>\n <body data-new-gr-c-s-loaded=\"14.1174.0\" style=\"font-family:arial, 'helvetica neue', helvetica, sans-serif;width:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0\">\n  <div dir=\"ltr\" class=\"es-wrapper-color\" lang=\"en\" style=\"background-color:#F6F6F6\"><!--[if gte mso 9]>\n\t\t\t<v:background xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"t\">\n\t\t\t\t<v:fill type=\"tile\" color=\"#f6f6f6\"></v:fill>\n\t\t\t</v:background>\n\t\t<![endif]-->\n   <table class=\"es-wrapper\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#F6F6F6\">\n     <tr style=\"border-collapse:collapse\">\n      <td valign=\"top\" style=\"padding:0;Margin:0\">\n       <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-content\" align=\"center\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\">\n         <tr style=\"border-collapse:collapse\">\n          <td align=\"center\" style=\"padding:0;Margin:0\">\n           <table bgcolor=\"#ffffff\" class=\"es-content-body\" align=\"center\" cellpadding=\"0\" cellspacing=\"0\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\">\n             <tr class=\"es-mobile-hidden\" style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"Margin:0;padding-top:5px;padding-bottom:5px;padding-left:20px;padding-right:20px\"><!--[if mso]><table style=\"width:560px\" cellpadding=\"0\" cellspacing=\"0\"><tr><td style=\"width:350px\" valign=\"top\"><![endif]-->\n               <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-left\" align=\"left\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td class=\"es-m-p20b\" align=\"left\" style=\"padding:0;Margin:0;width:350px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#000000;font-size:11px\">2024 Lincoln Way E Chambersburg, PA 17202</p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table><!--[if mso]></td><td style=\"width:20px\"></td><td style=\"width:190px\" valign=\"top\"><![endif]-->\n               <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-right\" align=\"right\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"left\" style=\"padding:0;Margin:0;width:190px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"right\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#666666;font-size:11px\">Call: <a target=\"_blank\" href=\"tel:(717)912-9066\" style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#333333;font-size:11px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif\">(717) 912-9066</a></p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table><!--[if mso]></td></tr></table><![endif]--></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:600px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0;font-size:0\">\n                       <table border=\"0\" width=\"100%\" height=\"100%\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                         <tr style=\"border-collapse:collapse\">\n                          <td style=\"padding:0;Margin:0;border-bottom:6px solid #cccccc;background:unset;height:1px;width:100%;margin:0px\"></td>\n                         </tr>\n                       </table></td>\n                     </tr>\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0;font-size:0px\"><a target=\"_blank\" href=\"https://www.chambersburghyundai.com/?utm_source=miq&utm_medium=email&utm_campaign=dor\" style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#2CB543;font-size:14px\"><img class=\"adapt-img\" src=\"https://hfnyib.stripocdn.email/content/guids/CABINET_e90c20ac59be83fd6cbcaf6028a808d38b996a05a63ae2cda9536e5349769bdd/images/chhbanner.png\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" width=\"600\"></a></td>\n                     </tr>\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0;font-size:0\">\n                       <table border=\"0\" width=\"100%\" height=\"100%\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                         <tr style=\"border-collapse:collapse\">\n                          <td style=\"padding:0;Margin:0;border-bottom:6px solid #cccccc;background:unset;height:1px;width:100%;margin:0px\"></td>\n                         </tr>\n                       </table></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:33px;color:#333333;font-size:22px\"><strong><span style=\"color:#696969\">Need help picking the right Hyundai Sonata?</span></strong></p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n           </table></td>\n         </tr>\n       </table>\n       <table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\">\n         <tr style=\"border-collapse:collapse\">\n          <td align=\"center\" style=\"padding:0;Margin:0\">\n           <table class=\"es-content-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\">\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-left:20px;padding-right:20px\">\n               <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">Hello Melanie,</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><br></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">Are you still dreaming about the Hyundai Sonata?</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><br>Here's what Car and Driver says in its review of the 2024 Hyundai Sonata*: \"Its mid-cycle refresh comes in the form of updated front and rear bumpers, new headlights and taillights, as well as big changes for the inside. While the Sonata retains its current powertrains, consisting of a 191-hp 2.5-liter four-cylinder and an N Line model with a 290-hp turbo four, all-wheel drive joins the options list for cars with the non-turbo. The 192-hp Sonata Hybrid that puts up big numbers for fuel economy also sticks around.\"</p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0;font-size:0px\"><img class=\"adapt-img\" src=\"https://images.dealer.com/ddc/vehicles/2024/Hyundai/Sonata/Sedan/trim_SEL_11d0d5/color/Ultimate%20Red-R2P-182%2C43%2C49-640-en_US.jpg?impolicy=downsize_bkpt&amp;imdensity=1&amp;w=520\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" width=\"520\"></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n           </table></td>\n         </tr>\n       </table>\n       <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-content\" align=\"center\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\">\n         <tr style=\"border-collapse:collapse\">\n          <td align=\"center\" style=\"padding:0;Margin:0\">\n           <table bgcolor=\"#ffffff\" class=\"es-content-body\" align=\"center\" cellpadding=\"0\" cellspacing=\"0\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\">\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:33px;color:#00254e;font-size:22px\"><strong><span style=\"color:#696969\">There’s a </span>SONATA for everyone.</strong></p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:10px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">Discover the ideal fit for your style among the distinct 2024 Hyundai Sonata trims:</p>\n                       <ul>\n                        <li style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;Margin-bottom:15px;margin-left:0;color:#696969;font-size:14px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><strong style=\"text-align:center\">SEL Trim:</strong> The SEL comes with plenty of must-have features. The 191 HP 2.5L MPI/GDI 4-cylinder engine provides plenty of power. It is available as a FWD and and AWD. The SEL comes with heated front seats, Bluelink connected car system, Proximity key with push button start, Android Auto and Apple Car Play.</p></li>\n                        <li style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;Margin-bottom:15px;margin-left:0;color:#696969;font-size:14px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><strong>N Line:</strong> The N Line ups the game with a 290 HP 2.5L Turbo MPI/GDI 4-cylinder engine that is coupled with the N 8-speed Wet Dual Clutch Trasnmission along with paddle shifters. It includes N Design 19-inch alloy wheels, N unique sport seats with microfiber inserts, panoramic sunroof, Highway Driving Assist (HDA). and a ton of driver safety features standard om top of all the SEL features.</p></li>\n                        <li style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;Margin-bottom:15px;margin-left:0;color:#696969;font-size:14px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><strong>SEL Hybrid:</strong> The hybrid drive train gives an impressive mileage of 47 MPG combined, 44 City/51 HWY. It comes standard with all the SEL features along with Wireless charging device, Hyundai Digital Key 2 Touch, Paddle shifters, LED projector headlights, and more</p></li>\n                        <li style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;Margin-bottom:15px;margin-left:0;color:#696969;font-size:14px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><strong>Limited Hybrid:</strong> The Limited Hybrid adds to the impressive feature list of the SEL Hybrid. It includes leather seating surfaces, Panoramic sunroof, Blind-Spot View Monitor (BVM), and Remote Smart Parking Assist (RSPA).&nbsp;</p></li>\n                       </ul><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">Selecting the proper trim depends on your needs, preferences and budget. Whatever your preferences, you can find these trims at Chambersburg Hyundai and take them for a test drive to better determine the best fit for you!</p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n           </table></td>\n         </tr>\n       </table>\n       <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-content\" align=\"center\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\">\n         <tr style=\"border-collapse:collapse\">\n          <td align=\"center\" style=\"padding:0;Margin:0\">\n           <table bgcolor=\"#ffffff\" class=\"es-content-body\" align=\"center\" cellpadding=\"0\" cellspacing=\"0\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\">\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px\"><!--[if mso]><table style=\"width:560px\" cellpadding=\"0\" cellspacing=\"0\"><tr><td style=\"width:194px\" valign=\"top\"><![endif]-->\n               <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-left\" align=\"left\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td class=\"es-m-p0r es-m-p20b\" align=\"center\" style=\"padding:0;Margin:0;width:174px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0\"><!--[if mso]><a href=\"https://www.chambersburghyundai.com/new-inventory/index.htm?model=Sonata&utm_source=miq&utm_medium=email&utm_campaign=dor\" target=\"_blank\" hidden>\n\t<v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" esdevVmlButton href=\"https://www.chambersburghyundai.com/new-inventory/index.htm?model=Sonata&utm_source=miq&utm_medium=email&utm_campaign=dor\" \n                style=\"height:36px; v-text-anchor:middle; width:165px\" arcsize=\"0%\" stroke=\"f\"  fillcolor=\"#00254e\">\n\t\t<w:anchorlock></w:anchorlock>\n\t\t<center style='color:#ffffff; font-family:roboto, \"helvetica neue\", helvetica, arial, sans-serif; font-size:12px; font-weight:700; line-height:12px;  mso-text-raise:1px'>Sonata Inventory</center>\n\t</v:roundrect></a>\n<![endif]--><!--[if !mso]><!-- --><span class=\"msohide es-button-border\" style=\"border-style:solid;border-color:#2cb543;background:#00254e;border-width:0px;display:inline-block;border-radius:0px;width:auto;mso-hide:all\"><a href=\"https://www.chambersburghyundai.com/new-inventory/index.htm?model=Sonata&utm_source=miq&utm_medium=email&utm_campaign=dor\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;display:inline-block;background:#00254e;border-radius:0px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-weight:bold;font-style:normal;line-height:16.8px;width:auto;text-align:center;padding:10px 20px 10px 20px;mso-padding-alt:0;mso-border-alt:10px solid #00254e\">Sonata Inventory</a></span><!--<![endif]--></td>\n                     </tr>\n                   </table></td>\n                  <td class=\"es-hidden\" style=\"padding:0;Margin:0;width:20px\"></td>\n                 </tr>\n               </table><!--[if mso]></td><td style=\"width:173px\" valign=\"top\"><![endif]-->\n               <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-left\" align=\"left\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td class=\"es-m-p20b\" align=\"center\" style=\"padding:0;Margin:0;width:173px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0\"><!--[if mso]><a href=\"https://www.chambersburghyundai.com/sell-a-car-near-york-pa.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" target=\"_blank\" hidden>\n\t<v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" esdevVmlButton href=\"https://www.chambersburghyundai.com/sell-a-car-near-york-pa.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" \n                style=\"height:36px; v-text-anchor:middle; width:133px\" arcsize=\"0%\" stroke=\"f\"  fillcolor=\"#00254e\">\n\t\t<w:anchorlock></w:anchorlock>\n\t\t<center style='color:#ffffff; font-family:roboto, \"helvetica neue\", helvetica, arial, sans-serif; font-size:12px; font-weight:700; line-height:12px;  mso-text-raise:1px'>Value Trade</center>\n\t</v:roundrect></a>\n<![endif]--><!--[if !mso]><!-- --><span class=\"msohide es-button-border\" style=\"border-style:solid;border-color:#2cb543;background:#00254e;border-width:0px;display:inline-block;border-radius:0px;width:auto;mso-hide:all\"><a href=\"https://www.chambersburghyundai.com/sell-a-car-near-york-pa.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;display:inline-block;background:#00254e;border-radius:0px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-weight:bold;font-style:normal;line-height:16.8px;width:auto;text-align:center;padding:10px 20px 10px 20px;mso-padding-alt:0;mso-border-alt:10px solid #00254e\">Value Trade</a></span><!--<![endif]--></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table><!--[if mso]></td><td style=\"width:20px\"></td><td style=\"width:173px\" valign=\"top\"><![endif]-->\n               <table cellpadding=\"0\" cellspacing=\"0\" class=\"es-right\" align=\"right\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" style=\"padding:0;Margin:0;width:173px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0\"><!--[if mso]><a href=\"https://www.chambersburghyundai.com/financing/application.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" target=\"_blank\" hidden>\n\t<v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" esdevVmlButton href=\"https://www.chambersburghyundai.com/financing/application.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" \n                style=\"height:36px; v-text-anchor:middle; width:120px\" arcsize=\"0%\" stroke=\"f\"  fillcolor=\"#00254e\">\n\t\t<w:anchorlock></w:anchorlock>\n\t\t<center style='color:#ffffff; font-family:roboto, \"helvetica neue\", helvetica, arial, sans-serif; font-size:12px; font-weight:700; line-height:12px;  mso-text-raise:1px'>Financing</center>\n\t</v:roundrect></a>\n<![endif]--><!--[if !mso]><!-- --><span class=\"msohide es-button-border\" style=\"border-style:solid;border-color:#2cb543;background:#00254e;border-width:0px;display:inline-block;border-radius:0px;width:auto;mso-hide:all\"><a href=\"https://www.chambersburghyundai.com/financing/application.htm?utm_source=miq&utm_medium=email&utm_campaign=dor\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:14px;display:inline-block;background:#00254e;border-radius:0px;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-weight:bold;font-style:normal;line-height:16.8px;width:auto;text-align:center;padding:10px 20px 10px 20px;mso-padding-alt:0;mso-border-alt:10px solid #00254e\">Financing</a></span><!--<![endif]--></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table><!--[if mso]></td></tr></table><![endif]--></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">For a more personalized experience, visit our dealership, and test drive this amazing sedan. <br></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><br></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\">We look forward to seeing you soon.</p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:10px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#696969;font-size:14px\"><b>Chambersburg Hyundai</b><br></p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"center\" style=\"padding:0;Margin:0;font-size:0px\"><img class=\"adapt-img\" src=\"https://hfnyib.stripocdn.email/content/guids/CABINET_1434e16087b9624f40374acfd9abe09a0713e09f1afddeaa4b22873ad88679a5/images/chhdealershipbackground.jpg\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" width=\"560\"></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#696969;font-size:11px\">* Car and Driver Sonata Review: https://www.caranddriver.com/hyundai/sonata<br></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#696969;font-size:11px\">While great effort is made to ensure the accuracy of the information in this message, errors do occur so please verify information with a customer service rep. This is easily done by calling us at (717) 912-9066 or by visiting us at the dealership.</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#696969;font-size:11px\"><br>You are receiving this email because you inquired about or purchased a vehicle from Chambersburg Hyundai recently or in the past. If you prefer not to receive further emails from us, click the link below to unsubscribe. Alternatively, you can send a written request to the address below. We'll remove you from our list as quickly as possible.</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;line-height:16.5px;color:#696969;font-size:11px\"><br>To contact us, please visit www.chambersburghyundai.com or call (717) 912-9066.<br>This email was delivered to you by:<br>Chambersburg Hyundai<br>2024 Lincoln Way E Chambersburg, PA 17202<br>Powered by © myautoIQ | All Rights Reserved</p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n             <tr style=\"border-collapse:collapse\">\n              <td align=\"left\" bgcolor=\"#00254e\" style=\"padding:0;Margin:0;padding-left:20px;padding-right:20px;background-color:#00254e\">\n               <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"none\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                 <tr style=\"border-collapse:collapse\">\n                  <td align=\"center\" valign=\"top\" style=\"padding:0;Margin:0;width:560px\">\n                   <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\">\n                     <tr style=\"border-collapse:collapse\">\n                      <td align=\"left\" style=\"padding:0;Margin:0\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\"><br></p></td>\n                     </tr>\n                   </table></td>\n                 </tr>\n               </table></td>\n             </tr>\n           </table></td>\n         </tr>\n       </table></td>\n     </tr>\n   </table>\n  </div>\n </body>\n</html>
`



